require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./digital-realities-vr-hotel-avalon.json") })
        }
      }, "path---digital-realities-vr-hotel-avalon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---digital-realities-vr-hotel-avalon!./.cache/json/digital-realities-vr-hotel-avalon.json
// module id = 393
// module chunks = 231608221292675